import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import { DataProviderService } from './data-provider.service';
import { IAttribute } from './IAttribute';

// TODO: should be ported to TS in the future
@Injectable()
export class AttributeDataService {
    constructor(private dataProvider: DataProviderService) { }

    public attributeExists(id: string): Observable<boolean> {
        return this.getAttributes()
            .every(dict => dict.attributes[id] !== undefined);
    }

    /**
     * Returns an observable yielding only those attributes of the given array, which are actually defined
     * in the datasource.
     */
    public filterExisting(attributes: string[]): Observable<string[]> {
        return this.getAttributes()
        .map(dict => attributes.filter(a => dict[a] !== undefined));
    }

    /**
     * An important attribute value to distinguish between different kinds of models.
     * The returned value will be something like: ["accessory","frame","plate","prewall"]
     * Note that the array indexes are important, because the actual models refer to the respective model-group by index.
     */
    public getModelGroup(): Observable<string[]> {
        return this.getAttribute("model-group")
            .map(a => a.values);
    }

    public getAttribute(key: string): Observable<IAttribute> {
        return this.getAttributes().map(dict => {
            const attribute: IAttribute = dict[key];
            if (attribute === undefined)
                throw new Error(`Attribute "${key}" does not exist.`);

            return attribute;
        });
    }

    /**
     * Retrieves and returns the dictionary of attributes.
     */
    public getAttributes(): Observable<{ [key: string]: IAttribute }> {
        return this.dataProvider.getData(false)
            .map(dataSource => dataSource.attributes);
    }
}



// WEBPACK FOOTER //
// ./src/app/core/attribute-data.service.ts